import { cleanup, renderHook } from '@testing-library/react';

import { useConversation } from './useConversation';

describe('useConversationのテスト', () => {
  beforeEach(() => {
    cleanup();
  });
  it('キャラクターの名前を出力できる', () => {
    const { result } = renderHook(() => {
      return useConversation({
        role: 'fushima',
        children: <>宝物...？よくわかんないけど、どうしたらいいの？</>,
      });
    });
    expect(result.current.name).toBe('フシマ');
  });
});
